export default {
  'component.portalVersion.tip': '切换后会保留当前页面并刷新菜单',
  'component.portalVersion.classic': '经典版',
  'component.portalVersion.v2': '新版',
  'component.tagSelect.expand': '展开',
  'component.tagSelect.collapse': '收起',
  'component.tagSelect.all': '全部',
};
